<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
	.nav {
		margin-bottom: 20px;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/">
			<el-breadcrumb-item>App管理</el-breadcrumb-item>
			<el-breadcrumb-item>App列表</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box">
			<div class="form-item">
				<div class="form-name">App/AppID：</div>
				<el-input class="inp" v-model="form.app" size="small" placeholder="App名称 或 AppID"></el-input>
			</div>
			<div class="form-item">
				<div class="form-name">域名/IP：</div>
				<el-input class="inp" v-model="form.url" size="small" placeholder="域名 或 IP"></el-input>
			</div>
			<div class="form-item">
				<div class="form-name"></div>
				<div style="width: 580px;">
					<el-button size="small" @click="reset">重置</el-button>
					<el-button size="small" type="primary" @click="search">查询</el-button>
					<el-button size="small" type="danger" style="margin-right: 40px;" @click="addFunc">添加App</el-button>
				</div>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="app_id" label="AppID" width="140" align="center"></el-table-column>
			    <el-table-column prop="app_name" label="App名称" width="120" align="center"></el-table-column>

				<el-table-column prop="server_ip" label="IP" width="120" align="center"></el-table-column>
				<el-table-column prop="admin_url" label="后台地址" width="180" align="center"></el-table-column>
				<el-table-column prop="request_url" label="接口域名" width="180" align="center"></el-table-column>
				<el-table-column prop="share_url" label="分享域名" width="180" align="center"></el-table-column>
				<el-table-column prop="apk_url" label="APK地址" width="180" align="center"></el-table-column>
				<el-table-column prop="ios_url" label="iOS地址" width="180" align="center"></el-table-column>
				<el-table-column prop="remark" label="备注信息" width="180" align="center"></el-table-column>
				<el-table-column prop="add_time" label="创建日期" min-width="180" width="" align="center"></el-table-column>
				
				<el-table-column prop="is_top" fixed="right" label="操作" width="180" align="center" >
					<template slot-scope="scope">
						<div style="display: flex; flex-direction: row; justify-content: center;">
							<el-link type="primary" style="margin-right: 15px;" @click="editFunc(scope)">编辑</el-link>
							<el-link type="success" style="margin-right: 15px;" @click="deleteFunc(scope)">删除</el-link>
							<el-link type="danger" style="margin-right: 15px;" @click="AdminFunc(scope)">后台</el-link>
						</div>
					</template>
				</el-table-column>
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[10, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
		<el-dialog title="添加App" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000" :before-close="handleClose">
		  <addApp></addApp>
		</el-dialog>
		
		<el-dialog title="编辑App" :visible.sync="editVisible" :close-on-click-modal="false" width="1000" :before-close="handleClose">
		  <editApp :app_info="app_info"></editApp>
		</el-dialog>
		
	</div>
</template>

<script>
	
	import addApp from './addApp.vue';
	import editApp from './editApp.vue';
	
	export default {
		components:{
			addApp, editApp
		},
		data(){
			return {
				loading:false,
				dialogVisible:false,
				editVisible:false,
				app_info:{},
				// 表格数据
				currentPage:1,
				tableData: [],
				total:0,
				limit:10,
				// 搜索表单
				form:{
					app:'',
					url:''
				}
			}
		},
		created() {
			this.getData();
		},
		methods:{
			editFunc(scope){
				this.editVisible = true;
				this.app_info = scope.row;
			},
			deleteAppFunc(scope, _password){
				let _this = this;
				_this.$api.post("/App/deleteApp", {app_id:scope.row.app_id, password:_password}).then(res=>{
					if(res.code == 200){
						_this.$message({
							 message: '删除成功 ',
							 type: 'success',
						});
						_this.tableData.splice(scope.$index, 1);
					}else{
						_this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(res=>{
				});
			},
			passwordDelete(scope){
				let _this = this;
				this.$prompt('请输入操作密码', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				}).then(({ value }) => {
					_this.deleteAppFunc(scope, value);
				}).catch(() => {
				});
			},
			deleteFunc(scope){
				let _this = this;
				this.$confirm('此操作将永久删除该App, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.passwordDelete(scope);
				}).catch(() => { 
				});
			},
			AdminFunc(scope){
				window.open(scope.row.admin_url);
			},
			addFunc(){
				this.dialogVisible = true;
			},
			handleClose(){
				this.dialogVisible = false;
				this.editVisible = false;
			},
			chooseIndex(_index){
				this.balanceReset();
				this.index = _index;
			},
			search(){
				this.getData();
			},
			reset(){
				this.form = {
					app:'',
					url:''
				};
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/App/getAppList", {page:this.currentPage, limit:this.limit, ...this.form}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			},
			formatTimestamp(timestamp) {
				// 将时间戳转换为毫秒
				const date = new Date(timestamp * 1000);
				// 获取日期和时间的各个部分
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				// 格式化为字符串
				return `${year}-${month}-${day} ${hours}:${minutes}`;
			},
		}
	}
</script>

